import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// The Google OAuth client only authorises redirect URIs on `localhost` (see
// services/GoogleLogin.js — the URI is built from window.location.origin).
// CRA's dev server also answers on 127.0.0.1 and on the LAN IP it prints as
// "On Your Network", and from those origins the sign-in popup dies with
// `redirect_uri_mismatch`. Bounce to the localhost equivalent before anything
// mounts, so the flow can never start from an unregistered origin.
const wrongDevOrigin =
  process.env.NODE_ENV === 'development' &&
  window.location.hostname !== 'localhost';

if (wrongDevOrigin) {
  const url = new URL(window.location.href);
  url.hostname = 'localhost';
  window.location.replace(url.toString());
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
